import React, { useContext, useEffect, useState } from "react";
import { Grid } from "@mui/material";
import OCRContext from "../../context/ocr-context";
import UserContext from "../../context/user-context";
import AppLayout from "../../components/AppLayout/AppLayout";
import Tabbar from "../../components/Tabbar/Tabbar";
import UploadCard from "../../components/UploadCard/UploadCard";
import OCRCard from "../../components/OCRCard/OCRCard";
import SummaryCard from "../../components/SummaryCard/SummaryCard";
import { useStyles } from "./styles";
import * as pdfjsLib from "pdfjs-dist";

pdfjsLib.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjsLib.version}/pdf.worker.js`;

const ScanPage = () => {
  const classes = useStyles();
  const ocrCtx = useContext(OCRContext);
  const userCtx = useContext(UserContext);
  const [activePage, setActivePage] = useState(0);
  const [loading, setLoading] = useState(true);

  const checkPermission = () => {
    if (userCtx && userCtx.overriddenRole) {
      const { can_add_invoice } = userCtx.overriddenRole;
      if (!can_add_invoice) {
        window.location.href = "/";
      }
    }
  };

  useEffect(() => {
    if (userCtx.userId) {
      checkPermission();
      setLoading(false);
    }
  }, [userCtx.userId]);

  useEffect(() => {
    setActivePage(ocrCtx.activePage);
  }, [ocrCtx.activePage]);

  useEffect(() => {
    return () => {
      ocrCtx.resetOCRState();
    };
  }, []);

  useEffect(() => {
    if (activePage === 1 && ocrCtx.file) {
      const renderPdf = async () => {
        const buffer = await ocrCtx.file.arrayBuffer();
        const pdfDoc = await pdfjsLib.getDocument(buffer).promise;
        const page = await pdfDoc.getPage(1); // Render first page
        const viewport = page.getViewport({ scale: 1 });
        const canvas = document.getElementById("output");
        if (canvas) {
          canvas.height = viewport.height;
          canvas.width = viewport.width;
          const context = canvas.getContext("2d");
          await page.render({
            canvasContext: context,
            viewport: viewport,
          }).promise;
        }
      };
      renderPdf();
    }
  }, [activePage, ocrCtx.file]);

  return (
    <AppLayout>
      <Tabbar />
      <div className={classes.content}>
        {activePage === 0 ? (
          <Grid container spacing={2} justifyContent="center">
            <Grid item xs={12} md={12}>
              <UploadCard />
            </Grid>
          </Grid>
        ) : activePage === 1 ? (
          <Grid container spacing={2} justifyContent="center">
            <Grid item xs={12} md={12}>
              <OCRCard />
            </Grid>
            <Grid item xs={12} md={6} container justifyContent="center">
            <canvas
                className={`${classes.invoice} ${activePage === 1 ? classes.glowing : ""}`}
                id="output"
              />
            </Grid>
          </Grid>
        ) : activePage === 2 ? (
          <SummaryCard />
        ) : null}
      </div>
    </AppLayout>
  );
};

export default ScanPage;